import { render, staticRenderFns } from "./edit_grade.vue?vue&type=template&id=1a0eb55e&scoped=true"
import script from "./edit_grade.vue?vue&type=script&lang=js"
export * from "./edit_grade.vue?vue&type=script&lang=js"
import style0 from "./edit_grade.vue?vue&type=style&index=0&id=1a0eb55e&prod&scoped=true&lang=css"
import style1 from "./edit_grade.vue?vue&type=style&index=1&id=1a0eb55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0eb55e",
  null
  
)

export default component.exports